// i18n
import "./locales/i18n";

// scroll bar
import "simplebar/src/simplebar.css";

// highlight
import "./utils/highlight";

// lightbox
import "react-image-lightbox/style.css";

// map
import "mapbox-gl/dist/mapbox-gl.css";

// editor
import "react-quill/dist/quill.snow.css";

// slick-carousel
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// lazy image
import "react-lazy-load-image-component/src/effects/blur.css";
import "react-lazy-load-image-component/src/effects/opacity.css";
import "react-lazy-load-image-component/src/effects/black-and-white.css";

import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";

import App from "./App";

import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { CollapseDrawerProvider } from "./contexts/CollapseDrawerContext";
import { UserProvider } from "./contexts/UserContext";
import { HelmetProvider } from "react-helmet-async";
import { WssProvider } from "./contexts/WSSContext";
import React from "react";
import Bugsnag from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";

import { BUGSNAG_KEY, VERSION } from "src/config/config";

let BugsnagPlugin: ReturnType<typeof Bugsnag.getPlugin> | undefined;

if (BUGSNAG_KEY) {
    Bugsnag.start({
        plugins: [new BugsnagPluginReact()],
        apiKey: `${BUGSNAG_KEY}`,
        appVersion: `${VERSION}`,
        enabledReleaseStages: ["production", "staging"],
    });
    BugsnagPlugin = Bugsnag.getPlugin("react");
}

const ErrorBoundary = BugsnagPlugin
    ? BugsnagPlugin.createErrorBoundary(React)
    : (props: { children: any }) => props.children;

ReactDOM.render(
    <ErrorBoundary>
        <HelmetProvider>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
                <CollapseDrawerProvider>
                    <UserProvider>
                        <WssProvider>
                            <BrowserRouter>
                                <App />
                            </BrowserRouter>
                        </WssProvider>
                    </UserProvider>
                </CollapseDrawerProvider>
            </LocalizationProvider>
        </HelmetProvider>
    </ErrorBoundary>,
    document.getElementById("root")
);
